window.addEventListener('DOMContentLoaded', (event) => {
    
    // Load cart drawer on ajax add/update
    window.loadEgCartDrawer = async () => {
        const $cartDrawer = document.querySelector('#cart-drawer')
        if (!$cartDrawer) return;

        $cartDrawer.classList.add('show');

        const $form = $cartDrawer.querySelector('form')
        $form.style.opacity = '.2'

        const respoonse = await fetch(window.location.href)
        const data = await respoonse.text()

        const parser = new DOMParser()
        const newDocument = parser.parseFromString(data, 'text/html')
        const $cartdrawerbody = document.querySelector('body');
        $cartdrawerbody.classList.add('cart-drawer-show');
        $form.replaceWith(newDocument.querySelector('#cart-drawer form'))

        document.querySelector('#cart-icon-bubble-count')
            ?.replaceWith(newDocument.querySelector('#cart-icon-bubble-count'))
closeDrawerFunctn()
        initCartDrawerQuantity()
        initCartDrawerRemoveButtons()
        initCartGoal()
        if(document.querySelector('.drawer-product-recommendations')) {
            drawerRecommendation()
        }
        if(!document.querySelector('.drawer-product-recommendations')){
            initCartUpsells()
            reinitFlickity()
        }
        initCartNote()
    }
      window.closeEgCartDrawer = async () => {
        const $cartDrawer = document.querySelector('#cart-drawer')
         const $cartdrawerbody = document.querySelector('body');
        if ($cartDrawer) {
            $cartDrawer.classList.remove('show');  // Remove 'show' class to hide the drawer
            $cartdrawerbody.classList.remove('cart-drawer-show');
        }
      }

    // Handle closing the cart drawer
    const closeCartDrawer = () => {
        const $cartDrawer = document.querySelector('#cart-drawer');
        const $cartdrawerbody = document.querySelector('body');
        if ($cartDrawer) {
            $cartDrawer.classList.remove('show');  // Remove 'show' class to hide the drawer
            $cartdrawerbody.classList.remove('cart-drawer-show');
        }
    };

    // Attach event listener to close button
    const closeBtn = document.querySelector('#cart-drawer .btn-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', closeCartDrawer);  // Close drawer on click
    }
 const closeDrawerFunctn = () => {
 document.querySelectorAll('#cart-drawer .btn-close').forEach(($btn) => {
            $btn.addEventListener('click', async (e) => {
              const $cartDrawer = document.querySelector('#cart-drawer');
        const $cartdrawerbody = document.querySelector('body');
        if ($cartDrawer) {
            $cartDrawer.classList.remove('show');  // Remove 'show' class to hide the drawer
            $cartdrawerbody.classList.remove('cart-drawer-show');
        }
               })
        })

 }
    const openDrawerFromHeader = () => {
      const $bagIcons = document.querySelectorAll('.header__icon.header__icon--cart');
      const $cartDrawer = document.querySelector('#cart-drawer');
      const $cartdrawerbody = document.querySelector('body');
      $bagIcons.forEach($bagIcon => {
        $bagIcon.addEventListener('click', function(e){
          e.preventDefault();
          $cartDrawer.classList.add('show');
          $cartdrawerbody.classList.add('cart-drawer-show');
          window.scrollTo({
            top: 20,
            behavior: 'smooth'
        });
        })
      })
    }
    openDrawerFromHeader()
  
    // Handle quantity
    const initCartDrawerQuantity = () => {
        document.querySelectorAll('#cart-drawer quantity-input .quantity__input').forEach(($input) => {
            $input.addEventListener('change', async (e) => {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        line: $input.dataset.index,
                        quantity: Number($input.value)
                    })
                })
                loadEgCartDrawer()
            })
        })
    }
    initCartDrawerQuantity()

    // Handle remove buttons
    const initCartDrawerRemoveButtons = () => {
        document.querySelectorAll('cart-remove-button a').forEach(($btn) => {
            $btn.addEventListener('click', async (e) => {
                e.preventDefault();

                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        line: $btn.parentElement.dataset.index,
                        quantity: 0
                    })
                })
                loadEgCartDrawer()
            })
        })
    }
    initCartDrawerRemoveButtons()

    // Cart Goal - Animate width
    const initCartGoal = () => {
        const progressBar = document.querySelector('#eg-cart-drawer-goal .progress-bar')

        if (progressBar) {
            setTimeout(() => {
                progressBar.style.width = progressBar.dataset.width
            }, 250)
        }
    }
    initCartGoal()

    // Cart Upsells 
    const initCartUpsells = async () => {
        document.querySelectorAll('#eg-cart-drawer-upsells-slider button').forEach(btn => {
            btn.addEventListener('click', async (e) => {
                e.preventDefault()

                btn.querySelector('span').classList.add('hidden')
                btn.querySelector('.loading-overlay__spinner').classList.remove('hidden')

                const variantId = btn.closest('.cart-upsell_right').querySelector('select[name="id"]').value

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{
                            id: Number(variantId),
                            quantity: 1
                        }]
                    })
                })

                const data = await response.json()
                //console.log(data)

                loadEgCartDrawer()
            })
        }) 
    }
    initCartUpsells()

    function reinitFlickity() {
        // Get the Flickity instance associated with the element
        var flkty = Flickity.data('#eg-cart-drawer-upsells-slider');
        
        // If an instance already exists, destroy it
        if (flkty) {
            flkty.destroy();
        }
        if(document.querySelector('.cart-drawer-carousel')) {
            // Reinitialize the Flickity slider with new or default settings
            var newFlickity = new Flickity('#eg-cart-drawer-upsells-slider', {
                prevNextButtons: true,  // Display prev/next buttons
                pageDots: false,         // Display page dots for navigation
            });
        }
    }

    // Recommendation
    function drawerRecommendation() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
        
            observer.unobserve(productRecommendationsSection);
        
            const url = productRecommendationsSection.dataset.url;
            fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.drawer-product-recommendations');
        
                if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
                reinitFlickity();
                initCartUpsells();
                }
            })
            .catch(e => {
                console.error(e);
            });
        };
        
        const productRecommendationsSection = document.querySelector('.drawer-product-recommendations');
        const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
        
        observer.observe(productRecommendationsSection);
    }
    drawerRecommendation()

    // Cart Note
    const initCartNote = async () => {
        document.querySelectorAll('#eg-cart-drawer-note button').forEach((btn) => {
            btn.addEventListener('click', async (e) => {
                e.preventDefault()
                btn.querySelector('span').classList.add('hidden')
                btn.querySelector('.loading-overlay__spinner').classList.remove('hidden')
                const note = document.querySelector('#eg-cart-drawer-note textarea').value
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        note: note
                    })
                })
                const data = await response.json()
                console.log(data)

                btn.querySelector('span').classList.remove('hidden')
                btn.querySelector('span').textContent = '✓'
                btn.querySelector('.loading-overlay__spinner').classList.add('hidden')

                setTimeout(() => {
                    btn.querySelector('span').textContent = btn.dataset.text
                }, 2000)
            })
        })
    }
    initCartNote()
});

// cart drawer out of click closing cart drawer
const todoInputContainer = document.querySelector('.offcanvas-end');
const $cartdrawerbody = document.querySelector('body');
document.addEventListener('click', event => {
    if (event.target != todoInputContainer) {
        if(!event.target.classList.contains("close-call")){
            if(!event.target.classList.contains("cart-icon"))
            {
                if(!event.target.parentElement.parentElement.classList.contains("cstm-shopping-bag-wrapper--jtpl"))
                {
                    if(!event.target.classList.contains("cstm-shopping-bag-wrapper--jtpl"))
                    {
                        let draweclassremove = document.getElementById("cart-drawer");
                        draweclassremove.classList.remove('show');
                        $cartdrawerbody.classList.remove('cart-drawer-show');
                    }
                }
            }
        }
    }
});
todoInputContainer.addEventListener('click', (event) => {
    event.stopPropagation(); // Stop the click from bubbling to the document
});

document.addEventListener("DOMContentLoaded", () => {
 
  const elements = document.querySelectorAll(".text-capitalize");

  elements.forEach((element) => {
    element.textContent = element.textContent
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  });
});